<template>
	<div class="form-container">
		<div v-if="selectedTimeStatus === 'possible'">
			<h2 class="form-title">{{ userName }}님 예약 안내</h2>

			<p class="form-desc-head">
				서비스 예약이 완료 되었습니다.<br />
				지점 상황에 따라 고객님께 회신을 통해<br />
				예약일정이 변경 될 수 있습니다.
			</p>

			<hr class="form-hr" />

			<div class="form-dl-box">
				<h3 class="form-dl-box__title">예약 접수 현황</h3>
				<dl>
					<dt>지점</dt>
					<dd>{{ branchName }}</dd>
					<dt>날짜</dt>
					<dd>{{ reservationDate }}</dd>
					<dt>시간</dt>
					<dd>{{ reservationTime }}</dd>
					<dt>내용</dt>
					<dd>{{ reservationService }}</dd>
				</dl>
			</div>

			<div class="form-input-hint-wrap">
				<FormInputHint
					message="예약시간 3시간 전까지 취소 가능하며 그 이후로는 취소가 불가합니다."
				></FormInputHint>
				<FormInputHint
					message="예약 변경을 원하시는 경우 취소 후 다시 예약 해주세요."
				></FormInputHint>
			</div>

			<div class="form-group form-button">
				<div class="columns">
					<div class="column col-12">
						<AppButton
							@click="$router.push({ name: 'reservation' })"
							color="primary"
							x-large
							block
							>예약 확인</AppButton
						>
					</div>
					<div class="column col-12">
						<AppButton
							@click="$router.push({ name: 'reservation' })"
							color="secondary"
							x-large
							block
							>예약 취소</AppButton
						>
					</div>
				</div>
			</div>
		</div>
		<div v-else>
			<h2 class="form-title">{{ userName }}님 예약 대기 안내</h2>

			<p class="form-desc-head">서비스 대기 신청이 완료 되었습니다.</p>

			<hr class="form-hr" />

			<div class="form-dl-box">
				<h3 class="form-dl-box__title">대기 접수 현황</h3>
				<dl>
					<dt>지점</dt>
					<dd>{{ branchName }}</dd>
					<dt>날짜</dt>
					<dd>{{ reservationDate }}</dd>
					<dt>시간</dt>
					<dd>{{ reservationTime }}</dd>
				</dl>
			</div>

			<div class="form-group form-button">
				<div class="columns">
					<div class="column col-12">
						<AppButton
							@click="$router.push({ name: 'reservationWaiting' })"
							color="primary"
							x-large
							block
							>대기 확인</AppButton
						>
					</div>
					<div class="column col-12">
						<AppButton
							@click="$router.push({ name: 'reservationWaiting' })"
							color="secondary"
							x-large
							block
							>대기 취소</AppButton
						>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import AppButton from '@/components/common/Btn';
import FormInputHint from '@/components/common/FormInputHint';

export default {
	components: {
		AppButton,
		FormInputHint,
	},
	computed: {
		reservationResult() {
			return this.$store.getters['reservationStore/reservationResult'];
		},
		userName() {
			return this.$store.state.userStore.user.user_name;
		},
		branchName() {
			return this.reservationResult.branchName;
		},
		reservationDate() {
			return this.reservationResult.reservationDate;
		},
		reservationTime() {
			return this.reservationResult.reservationTime;
		},
		reservationService() {
			return this.reservationResult.reservationService;
		},
		selectedTimeStatus() {
			return this.reservationResult.selectedTimeStatus;
		},
	},
};
</script>

<style scoped>
.form-input-hint-wrap {
	margin-left: -1rem;
	margin-right: -1rem;
	padding: 0.75rem 1rem;
	background: #ededed;
}

.form-input-hint-wrap .form-input-hint:first-child {
	margin-top: 0;
}
</style>
